module.exports = __webpack_public_path__ + "img/icon_auge_pw-sichtbar.5a364729.svg";